'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.CollectionFilters = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _listeners = require('../utils/listeners');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var classes = {
  FILTER_ACTIVE: 'clc-Filters_Select-active'
};

var selectors = {
  FILTER: '[collection-filter-select]',
  SORT: '[collection-sort-select]'
};

var CollectionFilters = exports.CollectionFilters = function () {
  function CollectionFilters(_ref) {
    var el = _ref.el,
        context = _ref.context;
    (0, _classCallCheck3.default)(this, CollectionFilters);

    this.el = el;
    this.context = context;

    this.setupListeners();
  }

  (0, _createClass3.default)(CollectionFilters, [{
    key: 'setupListeners',
    value: function setupListeners() {
      this.listeners = new _listeners.Listeners();
      var filters = this.els.filters;
      var sort = this.els.sort;

      for (var i = 0; i < filters.length; i++) {
        this.listeners.add(filters[i], 'change', this.onSelectHandle.bind(this));
      }

      if (sort) {
        this.listeners.add(sort, 'change', this.onSelectHandle.bind(this));
      }
    }
  }, {
    key: 'onSelectHandle',
    value: function onSelectHandle(_ref2) {
      var target = _ref2.target;

      var tags = [];
      var filters = this.els.filters;
      var sort = null;
      if (this.els.sort) {
        sort = this.els.sort.value;
      }

      for (var i = 0; i < filters.length; i++) {
        var value = filters[i].value;

        if (value !== 'all') {
          tags.push(value);
        }
      }

      target.classList.toggle(classes.FILTER_ACTIVE, target.value !== 'all');

      if (sort) {
        this.el.dispatchEvent(new CustomEvent('filterChange', {
          detail: { tags: tags, sort: sort }
        }));
      } else {
        this.el.dispatchEvent(new CustomEvent('filterChange', {
          detail: { tags: tags }
        }));
      }

      target.blur();
    }
  }, {
    key: 'els',
    get: function get() {
      return {
        el: this.el,
        filters: this.context.getElements(selectors.FILTER),
        sort: this.context.getElement(selectors.SORT)
      };
    }
  }]);
  return CollectionFilters;
}();

var init = exports.init = function init(_ref3) {
  var el = _ref3.el,
      context = _ref3.context;

  // eslint-disable-next-line no-new
  new CollectionFilters({ el: el, context: context });
};